import { logger } from './logger-client.js'

export type RuntimeOwner = 'live' | 'rest' | 'fallback' | 'admin' | 'unknown'
export type TurnOwnerLabel = 'live' | 'rest' | 'system'
export type VisibleAnswerOwner = 'live' | 'rest' | 'orchestrator_gate' | 'none'

export interface TurnObservabilityPayload {
  turnId: string
  sessionId?: string
  runtimeOwner?: RuntimeOwner
  turnOwner?: TurnOwnerLabel
  visibleAnswerOwner?: VisibleAnswerOwner
  evidenceCount?: number
  route?: string
  intent?: string
  detail?: string
}

/** Structured turn correlation log — every pipeline step should call this with the same turnId. */
export function logTurnObservability(payload: TurnObservabilityPayload): void {
  logger.info('[live-first-turn]', {
    turnId: payload.turnId,
    sessionPrefix: payload.sessionId?.slice(0, 8),
    runtimeOwner: payload.runtimeOwner ?? 'unknown',
    turnOwner: payload.turnOwner,
    visibleAnswerOwner: payload.visibleAnswerOwner,
    evidenceCount: payload.evidenceCount,
    route: payload.route,
    intent: payload.intent,
    detail: payload.detail,
  })
}
